import { type Accessor, type ParentComponent, type Setter, createContext, createSignal } from "solid-js";

export const sidebarElementContext = createContext<{
	element: Accessor<Node | undefined>;
	setElement: Setter<HTMLDivElement | undefined>;
}>({
	element: () => undefined,
	setElement: () => undefined,
});

export const SidebarElementProvider: ParentComponent = (props) => {
	const [element, setElement] = createSignal<HTMLDivElement>();
	return (
		<sidebarElementContext.Provider value={{ element, setElement }}>{props.children}</sidebarElementContext.Provider>
	);
};
